import PropTypes from "prop-types";

import { chartNames } from "../../../consts";
import { t } from "../../../services";

import { Paragraph2 } from "../../../components";
import {
  AttributeItem,
  AttributeItemTitle,
  AttributesList,
  ColorIndicator,
  DashboardTooltipTitleWrapper,
  DashboardTooltipWrapper
} from "../styled";

const ChartTooltip = ({ id, active, payload, metricsConfig, label, showMetricNames }) => {
  let nullValues = 0;

  const total = payload
    ? payload.reduce((accumulator, currentValue) => {
      if (!currentValue.value) {
        nullValues += 1;
      }
      return accumulator + currentValue.value;
    }, 0)
    : 0;

  const nonNullLength = payload?.length - nullValues;

  const average = nonNullLength > 0 ? (total / nonNullLength).toFixed(1) * 1 : 0;
  const unitValues = Object.values(metricsConfig).map((item) => item.unit);
  const areUnitsEqual = unitValues.every((unit) => unit === unitValues[0]);
  const value =
    id === chartNames.CONNECTION_TIME || id === chartNames.RECONNECTION_TIME_DURING_FWU
      ? average
      : total;

  return (
    active &&
    payload &&
    payload.length && (
      <DashboardTooltipWrapper>
        <DashboardTooltipTitleWrapper>
          <Paragraph2>{label}</Paragraph2>
          {areUnitsEqual && <span>{value}</span>}
        </DashboardTooltipTitleWrapper>
        <AttributesList>
          {payload.map((attribute) => {
            const metric = metricsConfig && metricsConfig[attribute?.dataKey];

            return (
              <AttributeItem key={attribute?.dataKey} color={showMetricNames && attribute?.color}>
                <AttributeItemTitle>
                  <ColorIndicator color={attribute?.color} />
                  <Paragraph2>{metric?.name ? t(metric.name) : attribute?.dataKey}:</Paragraph2>
                </AttributeItemTitle>

                <span>
                  {attribute?.value} {metric?.unit && metric.unit}
                </span>
              </AttributeItem>
            );
          })}
        </AttributesList>
      </DashboardTooltipWrapper>
    )
  );
};

ChartTooltip.propTypes = {
  id: PropTypes.string,
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      dataKey: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired
    })
  ),
  label: PropTypes.string,
  metricsConfig: PropTypes.shape(PropTypes.object).isRequired,
  showMetricNames: PropTypes.bool
};

export default ChartTooltip;
